import { render, staticRenderFns } from "./LaboratoryPolicy.vue?vue&type=template&id=69ecabec&"
import script from "./LaboratoryPolicy.vue?vue&type=script&lang=js&"
export * from "./LaboratoryPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports